namespace TabAurous.Production {
    export interface DismantlingReturnForm {
        TransDate: Serenity.DateEditor;
        TransId: Serenity.StringEditor;
        Posted: LabelEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: DismantlingReturnItemsEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class DismantlingReturnForm extends Serenity.PrefixedContext {
        static formKey = 'Production.DismantlingReturn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DismantlingReturnForm.init)  {
                DismantlingReturnForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = LabelEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;
                var w6 = s.ImageUploadEditor;
                var w7 = DismantlingReturnItemsEditor;
                var w8 = s.DecimalEditor;

                Q.initFormType(DismantlingReturnForm, [
                    'TransDate', w0,
                    'TransId', w1,
                    'Posted', w2,
                    'VoucherNo', w1,
                    'VoucherTypeId', w3,
                    'AutoPosting', w4,
                    'UserId', w5,
                    'EmployeeId', w3,
                    'ProductItemImage', w6,
                    'ItemDetails', w7,
                    'FinancialYearId', w3,
                    'Pieces', w3,
                    'Weight', w8,
                    'NetWeight', w8,
                    'Remark', w1,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
